export const CATEGORY_COLOR_OPTIONS = [
  { name: "butter", color: "#FF69B4" },
  { name: "sky", color: "#60A5FA" },
  { name: "leaf", color: "#7ED321" },
  { name: "coral", color: "#FF806F" },
  { name: "stone", color: "#A5A5A5" },
  { name: "sand", color: "#D4C26A" },
] as const

export const DEFAULT_CATEGORY_COLOR = CATEGORY_COLOR_OPTIONS[0].color
